import { crypto as cv } from '@photo-vault/shared';

// A rating is the digit "1".."5", stored as a WCV1 container under K_album.
// Keep the plaintext minimal so we don't pay container overhead for nothing —
// we'll add JSON {r,v} only if/when versioning becomes a thing.
export async function encryptRating(rating: number, key: CryptoKey): Promise<string> {
  if (rating < 1 || rating > 5 || !Number.isInteger(rating)) {
    throw new Error(`invalid rating: ${rating}`);
  }
  return cv.encryptText(String(rating), key);
}

export async function decryptRating(packed: string, key: CryptoKey): Promise<number | null> {
  try {
    const text = await cv.decryptText(packed, key);
    const n = Number(text);
    if (!Number.isInteger(n) || n < 1 || n > 5) return null;
    return n;
  } catch {
    return null;
  }
}
